<app-news-feed [pageSize]="9" [showPagination]="true" [admin]="false"></app-news-feed>